import * as GiftValue from '../../constants/giftValue';
import BaseDisclosureController from '../base-disclosure.controller';

class GiftController extends BaseDisclosureController {

    constructor(_, $state, componentDataService, componentRegistryService, preFetchedData, disclosureService, loggerService, $location, $q, constants, fileSaver) {
        super( _,
              $location,
              $state,
              $q,
              'giftController',
              constants.DisclosureType.Gift,
              "/.coi.giftreview",
              preFetchedData,
              componentDataService,
              componentRegistryService,
              disclosureService,
              fileSaver,
              loggerService);  
        this.lineManager = preFetchedData.lineManager;
        this.executiveManagers = preFetchedData.executiveManagers;
        this.giftApprovalOfficerType = null;
        this.isDeadEnd = true;      
        this.giftValues = {};     
        this.appendix1Link = constants.Links.Appendix1;
        this.disableExecutiveOfficerChange = this.disclosureData.status === 'Amending';
    }

    updateDeadEndState(isDeadEnd) {
        this.isDeadEnd = isDeadEnd;
    }

    $onInit() {
        if (this._.get(this.disclosureData,"giftDetail.giftValue", null)) {
            this.onGiftApprovalOfficerQuestionsModelChanged('giftValue', this.disclosureData.giftDetail.giftValue.toString(), true);
        }
        if (this._.get(this.disclosureData,"giftDetail.totalValueOfGifts", null)) {
            this.onGiftApprovalOfficerQuestionsModelChanged('totalValueOfGifts', this.disclosureData.giftDetail.totalValueOfGifts.toString(), true);
        }
    }

    onGiftApprovalOfficerQuestionsModelChanged(giftValueType, giftValue, setup = false) {
        if (giftValue && giftValue.match(/\d*/)[0] !== '') {
            let value = this._.toInteger(giftValue);
            this._.set(this.giftValues, giftValueType, value);
        } else {
            this._.set(this.giftValues, giftValueType, null);
        }
        
        this._.forIn(this.giftValues, (value, key) => {
            if ((value && value > GiftValue.MinimumGiftValue && value <= GiftValue.ExecutiveGiftValue) && (setup || this.componentRegistryService.existsAndValid(key) === true)) {
                this.giftApprovalOfficerType = "lineManager";
            } 
            if ((value && value > GiftValue.ExecutiveGiftValue) && (setup || this.componentRegistryService.existsAndValid(key) === true)) {
                this.giftApprovalOfficerType = "executiveManager";
            } 
        });
    }

    belowMinimumDisclosableAmount() {
        return this.giftValues.giftValue > GiftValue.MinimumGiftValue || this.giftValues.totalValueOfGifts >= GiftValue.MinimumGiftValue  ? true : false;        
    }

    isGiftApprovalOfficerQuestionsActive() {
        let anyExist = [];
        this._.forIn(this.giftValues, (value, key) => {
            anyExist.push(this.componentRegistryService.existsAndValid(key) === true);
        });
        return !this.isDeadEnd && this._.findIndex(anyExist, (o) => { return o === true }) !== -1 && this.belowMinimumDisclosableAmount();
    }
}

GiftController.$inject = ['_', '$state', 'componentDataService', 'componentRegistryService', 'preFetchedData', 'disclosureService', 'loggerService', '$location', '$q', 'constants', 'FileSaver'];

export default GiftController;


// WEBPACK FOOTER //
// ./app/disclose/gift/gift.controller.js